export enum Anchors {
  AboutMe = 'about-me',
  AddGames = 'add-games',
  GamingProfiles = 'gaming-profiles',
  Subscription = 'subscription',
  SocialProfiles = 'social-profiles',
}
